<template>
  <Modal v-model="showModal" @on-ok="confirm" title="家庭成员信息">
    <ModalLayout>
      <FormLayout ref="repeatInfo" class="iv-p-b-20 iv-p-l-20 iv-p-r-20" :model="personInfo" :list="personForm"></FormLayout>
    </ModalLayout>
  </Modal>
</template>

<script>
import personForm from './family'
import Modal from '@/components/modal'
import ModalLayout from '@/components/modal/layout'
import FormLayout from '@/components/layout/form'

export default {
  data () {
    return {
      showModal: false,
      personForm: [],
      personInfo: {
        memberAge: null,
        monthAvgIncome: null,
        familyMemberId: '',
        yearPoorId: ''
      }
    }
  },
  created () {
    this.personForm = personForm.call(this)
  },
  watch: {
    //自动计算年龄
    personInfo: {
      handler(val) {
        if (val.birthday) {
          let birthday = val.birthday.getFullYear()
          let nowyear = new Date().getFullYear()
          this.personInfo.memberAge = nowyear - birthday
        } else {
          this.personInfo.memberAge = null
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    open (item) {
      this.personInfo = item ?? {
        memberAge: null,
        monthAvgIncome: null,
        familyMemberId: '',
        yearPoorId: ''
      }
      this.showModal = true
    },
    confirm () {
      this.$refs['repeatInfo'].validate((valid) => {
        if (!valid) {
          this.$Message.error('表单校验失败')
          return
        }
        this.showModal = false
        this.$emit('on-confirm', this.personInfo)
      })
    }
  },
  components: {
    Modal,
    ModalLayout,
    FormLayout
  }
}
</script>
